<template>
  <div class="autocomplete-popup__close-button-container  q-d-block q-d-md-none ">
    <button id="autocomplete-popup__close-button"
            class="autocomplete-popup__close-button q-btn q-position-relative"
            @click="popupStore.hideAutocomplete">
    </button>
  </div>
</template>

<script setup lang="ts">
import {usePopupStore} from "@/store/AutocompletePopup/PopupStore";

const popupStore = usePopupStore();
</script>

<style scoped>

.autocomplete-popup__close-button::after {
  position: absolute;
  left: 2px;
  top: -2px;
  flex-shrink: 0;
  width: 1.5rem;
  height: 1.5rem;
  margin-left: auto;
  content: "";
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");
  transform: rotate(90deg);
  background-repeat: no-repeat;
  background-size: 1.5rem;
}


#autocomplete-popup__close-button {
  z-index: 1090;
}
</style>